import React from "react";
import HowItWorks from "../pages/HowItWorks";
import Testimonialabout from "../pages/Testimonialabout";
import GSTCertificate from "./GSTCertificate";

const AboutSection = () => {
  return (
    <>
      {/* ================================
          ABOUT PAGE BANNER
      ================================= */}

     
<section className="page-banner">
      <div className="page-banner-container">
        <h2>
          ABOUT US
        </h2>
      </div>
    </section>
      {/* ================================
          ABOUT US SECTION
      ================================= */}

      <div
        className="section-full site-bg-light twm-abus-section-wrap wow fadeInDown pt-3"
        data-wow-offset="100"
        data-wow-delay="0.2"
      >
        <div className="container-fluid">
          <div className="row">

            {/* ================================
                LEFT CONTENT
            ================================= */}

            <div className="col-lg-6 col-md-12">
              <div className="twm-abus-st2-section">

                <div className="section-head left">

                  {/* Small Heading */}
                  <div className="twm-sm-title left">
                    About Garud Cab Service
                  </div>

                  {/* Main Heading */}
                  <h2 className="twm-large-title site-text-dark">
                    Reliable Rides for Every Destination
                  </h2>

                  {/* Description */}
                  <div className="section-head-detail">

                    Garud Cab Service is committed to providing convenient
                    and comfortable transportation for individuals, families,
                    and businesses. We make travelling easier by offering
                    dependable cab services for local trips, outstation
                    journeys, airport transfers, and special travel
                    requirements.

                    <br />
                    <br />

                    We believe a good journey begins with a reliable cab.
                    That is why we focus on comfortable vehicles, experienced
                    drivers, timely pickups, and helpful customer support.
                    Every booking is handled with care so that passengers can
                    enjoy their journey without unnecessary travel concerns.

                    <br />
                    <br />

                    From short city rides to long-distance road trips,
                    Garud Cab Service provides flexible travel options to
                    match your requirements. Whether you are travelling for
                    work, visiting family, catching a flight, or planning a
                    weekend trip, our goal is to make every ride comfortable,
                    smooth, and convenient.

                    <br />
                    <br />

                    With customer satisfaction at the heart of our service,
                    we continue to improve our travel solutions and provide
                    passengers with a dependable cab experience every time
                    they choose Garud Cab Service.

                  </div>
                </div>

                {/* ================================
                    SERVICE FEATURES
                ================================= */}

                <div className="twm-inline-list2">
                  <ul>

                    <li>
                      <i className="fa fa-check"></i>
                      Local City Cab Services
                    </li>

                    <li>
                      <i className="fa fa-check"></i>
                      Comfortable Outstation Travel
                    </li>

                    <li>
                      <i className="fa fa-check"></i>
                      Airport Pickup & Drop Services
                    </li>

                    <li>
                      <i className="fa fa-check"></i>
                      Experienced & Courteous Drivers
                    </li>

                    <li>
                      <i className="fa fa-check"></i>
                      Clean & Comfortable Vehicles
                    </li>

                    <li>
                      <i className="fa fa-check"></i>
                      Easy Booking & Flexible Travel Options
                    </li>

                    <li>
                      <i className="fa fa-check"></i>
                      Personal, Family & Corporate Travel
                    </li>

                    <li>
                      <i className="fa fa-check"></i>
                      Customer-Focused Travel Experience
                    </li>

                  </ul>
                </div>

              </div>
            </div>

            {/* ================================
                RIGHT IMAGE
            ================================= */}

            <div className="col-lg-6 col-md-12 twm-abus2right-pic">

              <img
                src="/images/About.png"
                alt="Garud Cab Service"
              />

              <div className="abus2-right-pic"></div>

            </div>

          </div>
        </div>
      </div>

      {/* ================================
          HOW IT WORKS SECTION
      ================================= */}
<GSTCertificate/>
      <HowItWorks />

      {/* ================================
          CUSTOMER TESTIMONIALS
      ================================= */}

      <Testimonialabout />

    </>
  );
};

export default AboutSection;
